var map = {
	"./Messages.jpg": 277,
	"./Messages.png": 278,
	"./book.png": 279,
	"./box.png": 280,
	"./building.png": 281,
	"./building2.png": 282,
	"./building3.png": 283,
	"./building4.png": 284,
	"./building6.png": 285,
	"./building8.png": 286,
	"./chat.png": 287,
	"./chat_01.png": 288,
	"./chat_02.png": 289,
	"./chat_icon.png": 290,
	"./cloud.png": 291,
	"./dashboard.png": 292,
	"./dot.png": 293,
	"./get_started_bg.png": 294,
	"./john.png": 295,
	"./left_leaf.png": 296,
	"./live_chat.png": 297,
	"./mobile.png": 298,
	"./panguin_img_one.png": 299,
	"./panguin_img_three.png": 300,
	"./panguin_img_two.png": 301,
	"./pluse.png": 302,
	"./richard.png": 303,
	"./right_leaf.png": 304,
	"./security.png": 305,
	"./service1.png": 306,
	"./service2.png": 307,
	"./service3.png": 308,
	"./service4.png": 309,
	"./service6.png": 310,
	"./service7.png": 311,
	"./service8.png": 312,
	"./skyp_1.png": 313,
	"./skyp_2.png": 314,
	"./support_dashboard.jpg": 315,
	"./tablet.png": 316,
	"./tablet1.png": 317,
	"./triangle.png": 318,
	"./video_icon.png": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;